"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entrance = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var formik_1 = require("formik");
var axios_1 = __importDefault(require("axios"));
var button_1 = require("@chakra-ui/button");
var form_control_1 = require("@chakra-ui/form-control");
var image_1 = require("@chakra-ui/image");
var input_1 = require("@chakra-ui/input");
var layout_1 = require("@chakra-ui/layout");
var react_2 = require("@chakra-ui/react");
var useEntrance_1 = require("./useEntrance");
var PageLoading_1 = require("../../common/loading/PageLoading");
var Entrance = function () {
    // 背景画像の設定
    var _a = (0, react_1.useState)((0, react_2.extendTheme)({
        styles: {
            global: {
                body: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                },
            },
        },
    })), theme = _a[0], setTheme = _a[1];
    var _b = (0, useEntrance_1.useEntrance)(), invideCodeLoading = _b.invideCodeLoading, initialValues = _b.initialValues, validateCode = _b.validateCode, onSubmit = _b.onSubmit, noInvitationCode = _b.noInvitationCode;
    var _c = (0, react_1.useState)(), entranceData = _c[0], setEntranceData = _c[1];
    var _d = (0, react_1.useState)(true), isEntranceLoading = _d[0], setIsEntranceLoading = _d[1];
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get("/api/entrance")
            .then(function (response) {
            setEntranceData(response.data);
            setTheme((0, react_2.extendTheme)({
                styles: {
                    global: {
                        body: {
                            backgroundImage: "url(\"" + response.data.background_image + "\")",
                            backgroundSize: "cover",
                            backgroundPosition: "center center",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        },
                    },
                },
            }));
        })
            .finally(function () {
            setIsEntranceLoading(false);
        });
    }, []);
    if (isEntranceLoading || invideCodeLoading)
        return (0, jsx_runtime_1.jsx)(PageLoading_1.PageLoading, {}, void 0);
    return ((0, jsx_runtime_1.jsx)(react_2.ChakraProvider, __assign({ theme: theme }, { children: (0, jsx_runtime_1.jsxs)(layout_1.Box, __assign({ textAlign: "center" }, { children: [(0, jsx_runtime_1.jsx)(image_1.Img, { src: entranceData.main_image, alt: "logo", mx: "auto" }, void 0), (0, jsx_runtime_1.jsx)(layout_1.Box, __assign({ pt: "8" }, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ validateOnBlur: false, initialValues: initialValues, onSubmit: onSubmit }, { children: function (_a) {
                            var values = _a.values, isSubmitting = _a.isSubmitting;
                            return ((0, jsx_runtime_1.jsx)(formik_1.Form, { children: (0, jsx_runtime_1.jsx)(formik_1.Field, __assign({ name: "code", validate: validateCode }, { children: function (_a) {
                                        var field = _a.field, form = _a.form;
                                        return ((0, jsx_runtime_1.jsxs)(form_control_1.FormControl, __assign({ w: {
                                                base: "80%",
                                                md: "40%",
                                            }, mx: "auto", pb: "3", isInvalid: form.errors.code ? true : false }, { children: [(0, jsx_runtime_1.jsx)(form_control_1.FormLabel, __assign({ textAlign: "center", fontSize: "1.6rem", htmlFor: "code", color: "#F9B812", fontWeight: "bold" }, { children: "\u62DB\u5F85\u30B3\u30FC\u30C9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044" }), void 0), (0, jsx_runtime_1.jsxs)(input_1.InputGroup, __assign({ size: "lg" }, { children: [(0, jsx_runtime_1.jsx)(input_1.Input, __assign({}, field, { id: "code", bg: "white", color: "gray.900", size: "lg", fontSize: "1.6rem", pr: "2rem" }), void 0), (0, jsx_runtime_1.jsx)(input_1.InputRightAddon, __assign({ p: "0" }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, __assign({ isLoading: isSubmitting, type: "submit", height: "100%", size: "lg", fontSize: "1.2rem" }, { children: "\u30ED\u30B0\u30A4\u30F3" }), void 0) }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(form_control_1.FormErrorMessage, { children: form.errors.code }, void 0)] }), void 0));
                                    } }), void 0) }, void 0));
                        } }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(layout_1.Box, __assign({ pt: "8" }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, __assign({ variant: "link", onClick: function () { return noInvitationCode(); }, fontSize: "1.2rem" }, { children: "\u62DB\u5F85\u30B3\u30FC\u30C9\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u65B9\u306F\u3053\u3061\u3089" }), void 0) }), void 0)] }), void 0) }), void 0));
};
exports.Entrance = Entrance;
